/**
 * Checks whether an element is at least partially visible within a scroll port
 * by comparing their bounding client rects horizontally.
 *
 * @param element - The element to check visibility for
 * @param scrollPortRect - The bounding client rect of the scroll port container
 * @returns `true` if the element is at least partially visible
 */
export function isElementVisibleInScrollPort(element, scrollPortRect) {
  const elementRect = element.getBoundingClientRect();
  return scrollPortRect.width === 0 || elementRect.left < scrollPortRect.right && elementRect.right > scrollPortRect.left;
}
//# sourceMappingURL=carousel-visibility-utils.js.map